export const EVENT_DETAIL_LOAD_ERROR_MESSAGE = "Failed to load event details.";
